import {Dialog, Transition} from '@headlessui/react';
import React, {Fragment} from 'react';
import ModalTitle from './ModalTitle';
import classNames from "classnames";

export enum ModalWidth {
  NARROW = 'max-w-lg',
  NORMAL = 'max-w-xl',
  WIDE = 'max-w-3xl'
}

type Props = {
  title?: string
  show: boolean
  onClose: () => void
  width?: ModalWidth
}

export default function Modal({
  title, show, onClose, width = ModalWidth.NORMAL, children,
}: React.PropsWithChildren<Props>) {
  return (
    <>
      <Transition appear show={show} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={onClose}
        >
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-40" />
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className={classNames("inline-block w-full p-6 my-8 overflow-hidden text-left align-middle " +
                "transition-all transform bg-white shadow-xl rounded-2xl overflow-visible", width)}>
                {title &&
                <ModalTitle title={title} onClose={onClose}/>
                }
                <div>
                  {children}
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
